import React, { useContext, useEffect, useState } from "react";

import clsx from "clsx";
import PerformanceSwiper from "./performance-swiper";
import DashboardContext from "src/context/dashboard-context";

type PortfolioDetailsPerformanceProps = {
  performanceData: Performance[];
  selectedPortfolio: any;
  selectedAccount: any;
};

const PortfolioDetailsPerformance: React.FC<
  PortfolioDetailsPerformanceProps
> = ({
  performanceData,
  selectedPortfolio,
}: PortfolioDetailsPerformanceProps) => {
  const { selectedAccount } = useContext(DashboardContext);
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    setData(
      performanceData.filter(
        (item: any) => item.portfolioCode == selectedPortfolio?.accountCode
      )
    );
  }, [selectedPortfolio, performanceData]);

  return (
    <div
      className={clsx(
        " w-full p-4 bg-white h-[230px] rounded-2xl add-shadow border border-[#e3e3e3] flex-col justify-start items-start gap-5 inline-flex overflow-hidden"
      )}
    >
      <div className="PortfolioPerformance h-5 text-[#2a2a2a] text-base font-bold font-['Montserrat']">
        Portfolio performance
      </div>
      {data?.length ? (
        <PerformanceSwiper
          performanceData={data}
          performanceDetails={false}
          selectedAccount={selectedAccount}
          selectedPortfolio={selectedPortfolio}
        />
      ) : (
        <div className="flex flex-col flex-grow justify-center items-center w-full">
          <img
            src={"/images/empty-performance-icon.svg"}
            width={40}
            height={40}
            alt="Empty Performance Icon"
          />
          <p className="text-neutral-400 text-sm mt-3">
            You have no performance yet
          </p>
        </div>
      )}
    </div>
  );
};

export default PortfolioDetailsPerformance;
